import { Text } from 'atoms/Text/Text';
import React from 'react';
import { Styles } from './styles';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { OUTSIDE_LINKS } from 'constants/paths';
import { useModal } from 'contexts/ModalProvider/ModalProvider';
import { ReportProblemModal } from '../ReportProblemModal/ReportProblemModal';
import { AlgoliaProduct } from 'models/products';

type ProductDisclaimerProps = {
  product: AlgoliaProduct;
};

export const ProductDisclaimer: React.FC<ProductDisclaimerProps> = ({ product }) => {
  const { handleModal } = useModal();

  const onReportIssue = () => {
    handleModal(<ReportProblemModal product={product} />);
  };

  return (
    <Styles.Wrapper>
      <Styles.Link onClick={onReportIssue}>Report a product issue</Styles.Link>
      <Styles.Line />
      <Text.caption2 color={defaultTheme.colors.secondaryGrey}>
        vTail does not provide clinical advice or diagnostic services <br />
        <br />
        Product information contained in this database should not be regarded as an alternative to
        clinical advice and you should always ensure that you seek the advice of a physician or
        other appropriately qualified healthcare practitioner with any questions relating to a
        medical condition or the use of a product. <br />
        <br />
        Information in this database is not a replacement for manufacturer instructions and it is
        your responsibility to verify any product information and its suitability for your intended
        use with the manufacturer.
        <br />
        <br />
        Access to the database and its content is subject to the terms of our disclaimer.{' '}
        <Styles.SmallLink target="_blank" href={OUTSIDE_LINKS.productDisclaimer}>
          View the disclaimer.
        </Styles.SmallLink>
      </Text.caption2>
    </Styles.Wrapper>
  );
};
